import React, { useEffect, useState } from "react";
import Editor from "../../../form/Editor";
import Input from "../../../form/Input";
import DatePicker from "../../../form/DatePicker";
import Select from "../../../form/Select";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import { addEditScholarship } from "../../../../services/scholarshipService";
import useMutation from "../../../../hooks/useMutation";
import { useDebounce } from "../../../../hooks/useDebounce";
import useFetch from "../../../../hooks/useFetch";
import { quizList } from "../../../../services/quizService";
import { removeDuplicateFromArray } from "../../../../helpers";
import FileUploadSingle from "../../../form/FileUploadSingle";
import Textarea from "../../../form/Textarea";
import Checkbox from "../../../form/Checkbox";
import Tooltip from "../../../elements/Tooltip";
import { applicationList } from "../../../../services/applicationFormService";
import { useGetPermission } from "../../../../hooks/useGetPermission";
import { toast } from "react-toastify";

const validation = {
  title: { required: true, message: "Title is required" },
  applicationFormId: { required: true, message: "Application Id required" },
  recipientTitle: { required: true, message: "Recipient Title is required" },
  scholarshipTitle: {
    required: true,
    message: "Scholarship Title is required",
  },
  maxNumberOfApply: { required: true, message: "Recipient is required" },
  scholarshipAmount: {
    required: true,
    message: "Scholarship Amount is required",
  },
  recurringOpen: [
    // { required: true, message: "Recurring open is required" },
    {
      type: "enum",
      enum: ["yes", "no", "Yes", "No", "YES", "NO"],
      message: "Recurring open must be one of Yes, No",
    },
    {
      type: "range",
      errorType: "info",
      max: 3,
      message: "Input value should be at max 3",
    },
  ],
  recurringClose: [
    // { required: true, message: "Recurring open is required" },
    {
      type: "enum",
      enum: ["yes", "no", "Yes", "No", "YES", "NO"],
      message: "Recurring open must be one of Yes, No",
    },
    {
      type: "range",
      errorType: "info",
      max: 3,
      message: "Input value should be at max 3",
    },
  ],
};

const ManageScholarship = ({
  getResponse = () => {},
  close = () => {},
  data,
}) => {
  const { permission, status } = useGetPermission("scholarships");

  const [quizFilters, setQuizsFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });
  const [quizskeyword, setQuizskeyword] = useState("");
  const quizsSearch = useDebounce(quizskeyword, 300);

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({ validationRules: validation });

  const {
    data: quizs,
    error: quizsError,
    isLoading: quizsLoading,
    updateData,
    isFetching,
    refetch,
  } = useFetch({
    dependencies: ["quizs", quizFilters, quizsSearch],
    fetchFunction: async () => {
      const res = await quizList({
        ...quizFilters,
        ...(quizsSearch && { keyword: quizsSearch }),
      });
      if (res?.docs?.status === 200) {
        return {
          ...res?.docs,
          data: removeDuplicateFromArray([
            ...(quizs?.data || []),
            ...res?.docs?.data,
          ]),
        };
      } else {
        if (quizs?.data?.length > 0) {
          return quizs;
        } else {
          return res;
        }
      }
    },
  });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({
        ...data,
        recurringOpen: data?.recurringOpen ? "yes" : "no",
        recurringClose: data?.recurringClose ? "yes" : "no",
        document: data?.document?.url,
      });
    }
  }, [data]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      if (permission?.add && status === "ok" && !data?._id) {
        return await addEditScholarship({
          ...val,
        });
      }
      if (permission?.edit && status === "ok" && data?._id) {
        return await addEditScholarship({
          ...val,
          ...(data?._id && { id: data?._id }),
        });
      }
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  function loadData(e, obj, setData = () => {}) {
    if (
      Math.ceil(e.target.scrollTop) + 20 >=
        e.target.scrollHeight - e.target.clientHeight &&
      obj?.metadata?.hasNextPage
    ) {
      setData((pre) => ({
        ...pre,
        page: obj?.metadata?.nextPage,
      }));
    }
  }
  const { data: appFormList } = useFetch({
    dependencies: ["appFormList"],
    fetchFunction: async () => {
      const res = await applicationList({
        limit: 9999,
      });
      return res?.docs;
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-4 gap-x-4 gap-y-4">
        <div className="relative col-span-4">
          <Input
            label={"Application Title"}
            inputPlaceholder={"Enter Application Title"}
            inputName="title"
            value={values?.title || ""}
            onChange={handleChange}
            {...formValidate(errors, "title")}
          />
        </div>
        <div className="relative col-span-2">
          <DatePicker
            type="input"
            label={"Open Date"}
            value={{
              startDate: values?.publishDate,
              endDate: values?.publishDate,
            }}
            onChange={(e) => {
              const end = new Date(values?.publishEndDate);

              const start = new Date(e?.startDate);
              if (values?.publishEndDate) {
                if (start > end) {
                  handleChange({
                    target: {
                      value: null,
                      name: "publishDate",
                    },
                  });
                  toast.info("Open date must be smaller then close date");
                } else {
                  handleChange({
                    target: { value: e?.startDate, name: "publishDate" },
                  });
                }
              } else {
                handleChange({
                  target: { value: e?.startDate, name: "publishDate" },
                });
              }
            }}
            {...formValidate(errors, "publishDate")}
          />
        </div>
        <div className="relative col-span-2">
          <DatePicker
            type="input"
            label={"Close Date"}
            value={{
              startDate: values?.publishEndDate,
              endDate: values?.publishEndDate,
            }}
            onChange={(e) => {
              const start = new Date(values?.publishDate);
              const end = new Date(e?.startDate);

              if (values?.publishDate) {
                if (start > end) {
                  handleChange({
                    target: {
                      value: null,
                      name: "publishEndDate",
                    },
                  });
                  toast.info("Close date must be smaller then open date");
                } else {
                  handleChange({
                    target: { value: e?.startDate, name: "publishEndDate" },
                  });
                }
              }
            }}
            {...formValidate(errors, "publishEndDate")}
          />
        </div>
        <div className="relative col-span-2 space-y-4">
          <div
            className={"text-xs font-medium text-shades-07 font-CanelaDeck "}
          >
            Choose Recurring
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="flex items-center gap-2">
              <Checkbox
                checkboxLabel={"Recurring Open?"}
                checkboxLableClass={"!text-sm"}
                checkboxName={"recurringOpen"}
                checked={values?.recurringOpen === "yes" ? true : false}
                onChange={(e) => {
                  handleChange({
                    target: {
                      name: e.target.name,
                      value: e.target.checked ? "yes" : "no",
                    },
                  });
                }}
              />
              <Tooltip
                position={"top"}
                messageClass="max-w-52"
                message={
                  "scholarship will automatically be available to the users on the front-end on the set open date each year"
                }
              >
                <i className="fa-fw fa-regular fa-info-circle text-chestnut-rose text-xs"></i>
              </Tooltip>
            </div>
            <div className="flex items-center gap-2">
              <Checkbox
                checkboxLabel={"Recurring Close?"}
                checkboxLableClass={"!text-sm"}
                checkboxName={"recurringClose"}
                checked={values?.recurringClose === "yes" ? true : false}
                onChange={(e) => {
                  handleChange({
                    target: {
                      name: e.target.name,
                      value: e.target.checked ? "yes" : "no",
                    },
                  });
                }}
              />
              <Tooltip
                position={"top"}
                messageClass="max-w-52"
                message={
                  "scholarship will automatically be unavailable to the users on the front-end on the set closed date each year"
                }
              >
                <i className="fa-fw fa-regular fa-info-circle text-chestnut-rose text-xs"></i>
              </Tooltip>
            </div>
          </div>
          {/* <div className="relative">
            <Input
              label={"Recurring Open?"}
              inputPlaceholder={"Enter Yes/No"}
              inputName="recurringOpen"
              value={values?.recurringOpen}
              onChange={handleChange}
              {...formValidate(errors, "recurringOpen")}
            />
          </div>
          <div className="relative">
            <Input
              label="Recurring Close?"
              inputPlaceholder={"Enter Yes/No"}
              inputName="recurringClose"
              value={values?.recurringClose}
              onChange={handleChange}
              {...formValidate(errors, "recurringClose")}
            />
          </div> */}
        </div>
        <div className="relative col-span-2">
          <Select
            label={"Assign Eligibility Quiz"}
            placeholder="Select Eligibility Quiz"
            selectedValue={values?.quizeId}
            dropdownData={removeDuplicateFromArray(
              [
                {
                  name: data?.quizeDetails?.title,
                  value: data?.quizeDetails?._id,
                },
                ...(quizs?.data || [])?.map((item) => ({
                  value: item?._id,
                  name: item?.title,
                })),
              ],
              "value"
            )}
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "quizeId", value: val },
              });
            }}
            onScroll={(e) => loadData(e, quizs, setQuizsFilters)}
          />
        </div>
        <div className="relative col-span-4">
          <Editor
            label="Requirements"
            placeholder="At Vpeters family scholarship, we believe in the "
            value={values?.requirement}
            onChange={(val) =>
              handleChange({ target: { name: "requirement", value: val } })
            }
            {...formValidate(errors, "requirement")}
          />
        </div>
        <div className="relative col-span-4">
          <Editor
            label="Application Instructions"
            placeholder="At Vpeters family scholarship, we believe in the "
            value={values?.applicationInstruction}
            onChange={(val) =>
              handleChange({
                target: { name: "applicationInstruction", value: val },
              })
            }
            {...formValidate(errors, "applicationInstruction")}
          />
        </div>
        <div className="relative space-y-2">
          <Input
            label={"Recipient Title"}
            inputPlaceholder={"Enter Recipients Title"}
            inputName="recipientTitle"
            value={values?.recipientTitle || ""}
            onChange={handleChange}
            {...formValidate(errors, "recipientTitle")}
          />
          <Input
            label={"Max Number of Recipients"}
            inputPlaceholder={"Enter Recipients Number"}
            inputName="maxNumberOfApply"
            value={values?.maxNumberOfApply || ""}
            onChange={handleChange}
            {...formValidate(errors, "maxNumberOfApply")}
          />
        </div>
        <div className="relative space-y-2">
          <Input
            label={"Scholarship Title"}
            inputPlaceholder={"Enter Scholarship Title"}
            inputName="scholarshipTitle"
            value={values?.scholarshipTitle || ""}
            onChange={handleChange}
            {...formValidate(errors, "scholarshipTitle")}
          />
          <Input
            label={"Scholarship Amount"}
            inputPlaceholder={"Enter Amount"}
            inputName="scholarshipAmount"
            value={values?.scholarshipAmount || ""}
            onChange={handleChange}
            {...formValidate(errors, "scholarshipAmount")}
          />
        </div>
        <div className="relative">
          <Select
            label="Application Form"
            placeholder="Select Application Form"
            selectedValue={values?.applicationFormId}
            dropdownData={
              appFormList?.data?.map((item) => ({
                name: item?.title,
                value: item?._id,
              })) || []
            }
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "applicationFormId", value: val },
              });
            }}
            {...formValidate(errors, "applicationFormId")}
          />
        </div>
        <div className="relative">
          <Select
            label={"Status"}
            placeholder="Select status"
            selectedValue={values?.status}
            dropdownData={[
              { name: "Published", value: 1 },
              { name: "Draft", value: 2 },
            ]}
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "status", value: val },
              });
            }}
          />
        </div>
        <div className="relative col-span-4">
          <Textarea
            label={"Admin Notes"}
            inputPlaceholder={"special instructions"}
            inputName={"notes"}
            inputValue={values?.notes || ""}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Submit"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ManageScholarship;
